import { DataBox } from './DataBox'
import { baseFleetModel } from '../fleetModel'
import { PageHeader } from './PageHeader'
import { AddFleetModal } from './addFleetModal'
import { EditFleetModal } from './editFleetModal'

export function BaseFleet() {
    const { addCarVisible, editCarVisible } = baseFleetModel()
    return (
        <>
            <PageHeader />
            <DataBox />
            {addCarVisible && <AddFleetModal />}
            {editCarVisible && <EditFleetModal />}
        </>
    )
}
